import {store} from "@/store/store";

export let connectPayment = () => {
  if (!store.state.isPaymentsScriptConnected) {
    let script = document.createElement('script');
    let head = document.head || document.documentElement.childNodes[0];

    script.type = 'text/javascript';
    script.src = 'https://widget.cloudpayments.ru/bundles/cloudpayments/?vers=1234';
    head.appendChild(script);
    store.commit('setStatusPaymentScript', true);
  }
};